var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector } from '@angular/core';
import { GmapsPoint } from './gmaps-point.model';
import { GmapsDirectionsDirective } from './gmaps-directions.directive';
import { MapsAPILoader } from '@agm/core';
import { BaseComponent } from './../base-components/base-component';
var GmapsHelpers = /** @class */ (function (_super) {
    __extends(GmapsHelpers, _super);
    function GmapsHelpers(injector) {
        var _this = _super.call(this, injector) || this;
        _this.zoom = 16;
        _this.mapsAPILoader = _this.injector.get(MapsAPILoader, (_this.mapsAPILoader = null));
        return _this;
    }
    GmapsHelpers.prototype.initGmapsDirections = function (origin, destination, inputRef) {
        var _this = this;
        if (this.directionsDirective) {
            this.directionsDirective.origin = origin;
            this.directionsDirective.destination = destination;
            if (this.directionsDirective.directionsDisplay === undefined) {
                this.mapsAPILoader.load().then(function () {
                    _this.directionsDirective.directionsDisplay = new google.maps.DirectionsRenderer();
                    if (inputRef) {
                        var autocompleteInput_1 = new google.maps.places.Autocomplete(inputRef.nativeElement, {
                            types: []
                        });
                        autocompleteInput_1.addListener('place_changed', function () {
                            var place = autocompleteInput_1.getPlace();
                            if (place.geometry === undefined)
                                return;
                            _this.updatePath(place.geometry.location.lat(), place.geometry.location.lng());
                        });
                    }
                });
            }
            if (destination)
                this.directionsDirective.updateDirections();
        }
        else {
            throw new Error('GmapsHelpers error: GmapsDirectionsDirective undefined.');
        }
    };
    GmapsHelpers.prototype.updatePath = function (lat, lng, additionalText) {
        this.directionsDirective.destination = new GmapsPoint(parseFloat(lat.toString()), parseFloat(lng.toString()));
        this.directionsDirective.updateDirections(additionalText);
    };
    GmapsHelpers.prototype.changeTravelMode = function (mode) {
        this.directionsDirective.travelMode = mode;
        this.directionsDirective.updateDirections();
    };
    return GmapsHelpers;
}(BaseComponent));
export { GmapsHelpers };



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/gmaps-helpers.model.ts.pre-build-optimizer.js